const initMFE = import('./initMFE')

export const bootstrap = (...args: unknown[]) => initMFE.then(m => m.bootstrap(...args))
export const mount = (...args: unknown[]) => initMFE.then(m => m.mount(...args))
export const unmount = (...args: unknown[]) => initMFE.then(m => m.unmount(...args))
